import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import BrandsTableDetails from "./BrandsTableDetails";
import {
  deleteBrandById,
  fetchAllBrand,
} from "../../../../redux/reducer/brandReducer";
import { fetchAreas, UpdateArea } from "../../../../redux/reducer/areaReducer";

const SelectBrandsSettings = ({ area, areaID }) => {
  const dispatch = useDispatch();
  const { allBrands, loading, error } = useSelector((state) => state.brands);
  const { t } = useTranslation();

  const headers = [
    "Select",
    "ID",
    "Title EN",
    "Title AR",
    "Link",
    "image",
    "Area",
    "Category",
    "SubCategory",
    // 'Actions',
  ];
  const [selectedIds, setSelectedIds] = useState([]);
  const { areas, loadingAreas } = useSelector((state) => state.areas);

  const handleCheckboxChange = (brandId, checked) => {
    setSelectedIds((prev) => {
      if (checked) {
        if (prev.length >= 10) {
          alert("You cannot select more than 10 items.");
          return prev;
        }
        return [...prev, brandId];
      } else {
        return prev.filter((id) => id !== brandId);
      }
    });
  };
  // console.log(selectedIds)

  const sendSelectedToApi = async () => {
    try {
      const payload = {
        brand: selectedIds, // assuming API expects { brands: [ids] }
      };

      await dispatch(UpdateArea({ id: areaID, data: payload })).unwrap();
      alert("Brands updated successfully for the area!");
    } catch (err) {
      console.error("Update failed:", err);
      alert("Failed to update brands for area.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchAllBrand(`/?area=${areaID}`));
      const fetchedAreas = await dispatch(fetchAreas()).unwrap();

      const matchedArea = fetchedAreas.find((area) => area?._id === areaID);

      if (matchedArea?.brand?.length > 0) {
        const selectedBrandIds = matchedArea.brand.map((brand) => brand._id);
        setSelectedIds(selectedBrandIds);
        // console.log("Selected Brand IDs:", selectedBrandIds);
      }
    };

    fetchData();
  }, [dispatch]);

  const filteredBrands = allBrands.filter((brand) => brand.area._id === areaID);

  // console.log(filteredBrands);
  return (
    <div className="mx-auto overflow-x-auto rounded-xl">
      <div className="flex justify-between my-4">
        <h1 className="text-xl font-bold text-black">{area} Brands</h1>
        <button
          className="flex gap-3 px-3 py-2 duration-300 rounded-lg bg-custom-yellow hover:bg-black group"
          onClick={sendSelectedToApi}
        >
          {/* <PlusIcon className="w-6 h-6 text-black group-hover:text-white" /> */}
          <span className="text-black group-hover:text-white">Submit</span>
        </button>
      </div>

      {loading || loadingAreas ? (
        <p className="text-center text-gray-600">{t("Loading...")}</p>
      ) : error ? (
        <p className="text-center text-red-500">
          {t("Error")}: {error}
        </p>
      ) : allBrands?.length === 0 ? (
        <p className="text-center text-gray-500">{t("No data found")}</p>
      ) : (
        <table className="w-full my-5">
          <thead>
            <tr className="text-sm text-black bg-custom-yellow">
              {headers.map((header, index) => (
                <th key={index} className="px-2 py-2 font-bold text-center">
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {filteredBrands?.map((brand, index) => (
              <BrandsTableDetails
                key={brand._id || index}
                index={index + 1}
                details={{
                  id: brand._id,
                  number: index + 1,
                  img: brand.img,
                  link: brand.link,
                  nameEN: brand.name?.en,
                  nameAR: brand.name?.ar,
                  area: brand.area?._id,
                  areaName: brand.area?.name?.en,
                  category: brand.category?._id,
                  categoryName: brand.category?.title?.en,
                  subCategory: brand.subCategory?._id,
                  subCategoryName: brand.subCategory?.name?.en,
                  desc: brand.desc,
                }}
                isSelected={selectedIds.includes(brand._id)}
                onCheckboxChange={handleCheckboxChange}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SelectBrandsSettings;
